import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import {
    RadioRowDiv,
    Title,
    PhysicianTerritoryStyle,
} from 'src/pages/reportUsage/procedure/components/physician/PhysicianTerritory/PhysicianTerritory.styled';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import { OptionalLoadMoreView } from 'src/pages/scheduleSurgery/components/details/Details.styled';
import AccountPhysicianTemplate from 'src/pages/scheduleSurgery/components/details/AccountPhysicianTemplate';
import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import {
    getDropdownValues,
    clearSingleDropDownList,
    loadAllPhyscianLoading,
} from 'src/pages/scheduleSurgery/redux/actions';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import { useTranslation } from 'react-i18next';
import { setPhysicianProcedureDropdownValue } from 'src/pages/reportUsage/redux/action/actionCreators';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { MANDATORY, NOT_MANDATORY, VISIBLE } from 'src/constants/appConstants';
import { debounce, logErrorToConsole } from 'src/utils/util';
import { BASE_TEXT_PX, FONT_FAMILY_REGULAR, DISABLED_FONT_COLOR, TERTIARY_FONT_COLOR, X_SMALL_TEXT_PX, PRIMARY_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';

const PhysicianTerritory = ({
    selectedPhysicianData,
    setSelectedPhysicianData,
    physicianInputValue,
    setPhysicianInputValue,
    zIndex,
    showProcedureDropdown,
    isFromProcedure,
    isReportUsageFlow,
}) => {
    const winWidth = window.innerWidth;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const physicianRef = useRef();
    const { surgeryDetails, physicians, type } = useSelector((state) => ({
        surgeryDetails: state.surgeryReducer.surgeryDetails,
        physicians: state.detailsDropdownsReducer.physicianList.items,
        type: state.reportUsageRootReducer.physicianType,
    }));

    const { physicianId, template } = surgeryDetails;
    const { physiciansOptionLoading, physicianLoadAllLoading, physicianId: selectedPhysicianId } = useSelector(
        (state) => ({
            accountsOptionLoading:
                state.detailsDropdownsReducer.accounts.loading,
            physiciansOptionLoading:
                state.detailsDropdownsReducer.physicianList.loading,
            physicianLoadAllLoading:
                state.detailsDropdownsReducer.physicianList
                    .physicianLoadAllLoading,
            physicianId: state.reportUsageRootReducer.physicianDropdownValue.physicianId,
        })
    );

    const closekeyBoard = () => {
        document.activeElement.blur();
    };
    const [switchToTerritory, setSwitchToTerritory] = useState(true);
    const [initialPhysicianTypeEvaluated, setInitialPhysicianTypeEvaluated] =
        useState(false);
    const [initialAllRequestTriggered, setInitialAllRequestTriggered] =
        useState(false);
    const hasInitialAllLoadStartedRef = useRef(false);
    const [physiciantype, setPhysicianType] = useState(type);
    const [disableFields, setDisableFields] = useState({
        account: false,
        physician: false,
        template: false,
    });
    const {
        physicianDropdownZGReportUsageVisibility,
        physicianDropdownZGReportUsageMandatory,
    } = useSelector((state) => state.loginReducer);

    const usageDetails1 = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );

    const { loadAll } = useSelector((state) => ({
        loadAll: state.detailsDropdownsReducer.physicianList.loadAll,
    }));
    const showOptionsAfterClose = (value, flag) => {
        setTimeout(() => {
            try {
            handleDisableField(value, flag);
              } catch (error) {
                logErrorToConsole(error);
            }
        }, 700);
    };
    //  const [physicianSelection, setPhysicianSelection] = useState('');
    //  const [physicianSelectionValue, setPhysicianSelectionValue] = useState('');

    useEffectWithErrorLogging(() => {
        let gridDataValues = '';
        //gridData?.[0]?.shippingDetails?.physicianId;
        // const defaultPhysician=  physicianList.find((item)=>{
        //      return item?.physicianId == usageDetails?.physicianId;
        //  });
        const physicianId = usageDetails1?.physicianId;
        const physicianDisplayName = usageDetails1?.physicianName;
        const physicianFormattedName =
            usageDetails1?.physicianName + ' ' + usageDetails1?.physicianId;
        const defaultPhysician = {
            physicianId,
            physicianDisplayName,
            physicianFormattedName,
        };
        let defaultPhysicianValue1 = gridDataValues
            ? gridDataValues
            : defaultPhysician
            ? defaultPhysician
            : '';
        //physicianAutoCompleteChangeHandler(defaultPhysicianValue1,'');
        //    // setSelectedPhysicianData() -> object
        //      handleSearch('', defaultPhysicianValue1.physicianDisplayName, '', 'physician');
        //     //setPhysicianInputValue(defaultPhysicianValue1.physicianDisplayName);
        //     setPhysicianSelectionValue(defaultPhysicianValue1.physicianDisplayName);
        //     setPhysicianSelection(defaultPhysicianValue1);
        //     physicianAutoCompleteChangeHandler(defaultPhysicianValue1, true);
        //     handleSearch(null, defaultPhysicianValue1.physicianDisplayName, 'reset', 'physician');
        dispatch(
            setPhysicianProcedureDropdownValue({
                procedureDropdownValue: defaultPhysicianValue1,
            })
        );
        //    let favorite;
        //    let recentlyUsed;
        //    let physicanFormattedName;
        //    const obj={
        //     favorite: false,
        //     physicianDisplayName,
        //     physicianId,
        // recentlyUsed= true,
        // physicanFormattedName = "Dummy 27602"
        //   }
        //    setSelectedPhysicianData({
        //     favorite: false,
        //     physicianDisplayName,
        //     physicianId,
        //     recentlyUsed,
        //     physicanFormattedName
        //   });
    }, [usageDetails1]);

    const AccountTemplate = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                // eslint-disable-next-line no-undef
                data={fieldname == 'account' ? accounts : physicians}
                optionValue={
                    fieldname == 'account' ? 'accountId' : 'physicianId'
                }
                fieldname={fieldname}
                onLoadMore={() => handleLoadAll(true)}
                showLoadMore={!loadAll}
                showOptionLoader={physicianLoadAllLoading}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };
    const { physicianName } = useSelector((state) => ({
        physicianName:
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.physicianName,
    }));

    const isFavoritePhysician = (physician) => {
        const favoriteValue = physician?.favorite ?? physician?.isFavorite;
        return (
            favoriteValue === true ||
            favoriteValue === 'true' ||
            Number(favoriteValue) === 1
        );
    };

    // useEffectWithErrorLogging(()=>{
    //     if(salesOrg === 'S024'){
    //         setPhysicianInputValue(physicianName);
    //         setSelectedPhysicianData(physicianName);
    //     }
    // },[]);
    
    useEffectWithErrorLogging(() => {
        if (initialAllRequestTriggered || initialPhysicianTypeEvaluated) {
            return;
        }

        const hasSelectedPhysicianData = Boolean(
            selectedPhysicianData?.physicianId ||
                selectedPhysicianData?.physicianDisplayName
        );
        const selectedPhysicianDisplayName =
            hasSelectedPhysicianData
                ? selectedPhysicianData?.physicianDisplayName ||
                  usageDetails1?.physicianName ||
                  usageDetails1?.physicianDisplayName ||
                  ''
                : '';

        setInitialAllRequestTriggered(true);
        getPhysicanList({
            searchValue: selectedPhysicianDisplayName,
            loadAll: false,
            type: 'All',
        });
    }, [
        initialAllRequestTriggered,
        initialPhysicianTypeEvaluated,
        selectedPhysicianData,
        usageDetails1?.physicianDisplayName,
        usageDetails1?.physicianName,
    ]);

    useEffectWithErrorLogging(() => {
        if (!initialAllRequestTriggered || initialPhysicianTypeEvaluated) {
            return;
        }

        if (physiciansOptionLoading) {
            hasInitialAllLoadStartedRef.current = true;
            return;
        }

        if (!hasInitialAllLoadStartedRef.current) {
            return;
        }

        const hasSelectedPhysicianData = Boolean(
            selectedPhysicianData?.physicianId ||
                selectedPhysicianData?.physicianDisplayName
        );
        const selectedPhysicianIdValue = hasSelectedPhysicianData
            ? selectedPhysicianData?.physicianId || ''
            : '';
        const matchedSelectedPhysician = selectedPhysicianIdValue
            ? (physicians || []).find(
                  (physician) =>
                      physician?.physicianId === selectedPhysicianIdValue
              )
            : null;
        const hasFavoritePhysician = (physicians || []).some(
            (physician) => isFavoritePhysician(physician)
        );
        const shouldStayOnFavorites = hasSelectedPhysicianData
            ? isFavoritePhysician(matchedSelectedPhysician)
            : hasFavoritePhysician;

        if (shouldStayOnFavorites) {
            setPhysicianType('favorites');
            dispatch(
                setPhysicianProcedureDropdownValue({
                    physicianType: 'favorites',
                })
            );
            dispatch(
                clearSingleDropDownList({
                    name: 'physicianList',
                })
            );
            getPhysicanList({
                searchValue: '',
                loadAll: false,
                type: 'favorites',
            });
        } else {
            setPhysicianType('Territory');
            dispatch(
                setPhysicianProcedureDropdownValue({
                    physicianType: 'Territory',
                })
            );
            handleDisableField('physician', false);
        }

        setSwitchToTerritory(false);
        setInitialPhysicianTypeEvaluated(true);
    }, [
        dispatch,
        initialAllRequestTriggered,
        initialPhysicianTypeEvaluated,
        physicians,
        physiciansOptionLoading,
        selectedPhysicianData,
    ]);

    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;

    const handleSearch = (event, value, reason, fieldname) => {
        if (reason != 'reset') {
            const option = {
                searchValue: value?.trim() || '',
            };
            if (fieldname == 'physician') {
                setPhysicianInputValue(value);
                debouncedGetList(getPhysicanList, option);
            }
            
        } else {
            if (fieldname == 'physician') {
                setPhysicianInputValue(value);
                // handleInputChange(
                //     'physicianDropDown',
                //     physiciantype === 'favorites' ? '' : 'All'
                // );
            }
        }
    };
    const [searchLoadAll, setSearchLoadAll] = useState(false);
    const handleLoadAll = (loadAnimation) => {
        setPhysicianInputValue('');
        setSearchLoadAll(true);
        dispatch(loadAllPhyscianLoading(loadAnimation ? loadAnimation : false));
        getPhysicanList({
            searchValue: '',
            loadAll: true,
        });
    };

    const renderNoOption = (
        <OptionalLoadMoreView height={physiciantype != 'Territory' && '150px'}>
            {physiciantype == 'Territory' ? (
                <>
                    <p
                        style={{
                            fontSize: X_SMALL_TEXT_PX,
                        }}
                    >
                        {t('scheduleSurgery.details.notRecetPhysicianMSG')}
                        <br />
                        {t('scheduleSurgery.details.trySearchingByTypeMSG')}
                    </p>
                    <p>
                        {t('scheduleSurgery.details.cantFindWhoYou')}
                        <br />
                        {t('scheduleSurgery.details.areLookingFor')}
                    </p>
                    <button
                        onMouseDown={() => {
                            try {
                            handleLoadAll(true);
                             } catch (error) {
                            logErrorToConsole(error);
                        }
                        }}
                    >
                        {t('scheduleSurgery.details.loadAllPhysicians')}
                    </button>
                </>
            ) : (
                <>
                    <p
                        style={{
                            marginBottom: '7px',
                        }}
                    >
                        {t('scheduleSurgery.details.noFavoritePhysuciansSet')}
                    </p>
                    <button
                        style={{ width: '236px', fontSize: '15px' }}
                        onMouseDown={() => {
                            try {
                            physicianTypeChange(
                                physiciantype === 'Territory'
                                    ? 'favorites'
                                    : 'Territory',
                                true
                            );
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                        }}
                    >
                        {t(
                            'scheduleSurgery.details.switchToTerritoryPhysicians'
                        )}
                    </button>
                </>
            )}
        </OptionalLoadMoreView>
    );
    const { salesOrg, procedureDataPhysicianEquity, procedureDataPhysician } =
        useSelector((state) => ({
            salesOrg: state.loginReducer.salesOrg,
            procedureDataPhysician: state.loginReducer?.procedureDataPhysician,
            procedureDataPhysicianEquity:
                state.loginReducer?.procedureDataPhysicianEquity,
        }));

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const mandate =
        procedureDataPhysicianEquity === VISIBLE ||
        procedureDataPhysician === VISIBLE;
    const getPhysicanList = (data) => {
        const { searchValue, loadAll, type } = data;
        const params = {
            physicianType: type
                ? type
                : physiciantype == 'favorites'
                ? 'favorites'
                : 'All',
            isLoadAll: searchLoadAll ? searchLoadAll : loadAll,
            isSurgeryFlow: true,
            searchTerm: searchValue ? searchValue : '',
            templatePk: template?.templateUID,
            sapPartnerId: orderBasicDetails.accountNumber,
        };

        dispatch(
            getDropdownValues({
                dropDownName: 'physicianList',
                value: params,
                salesOrg: salesOrg,
                countryISOCode: countryISOCode,
            })
        );
    };
    const handleOnfocus = (event, field) => {
        if (field == 'physicians') {
            physicianOnfocus();
        }
    };
    const physicianOnfocus = () => {
        if (physicians.length == 0) {
            getPhysicanList({
                searchValue: physicianInputValue,
                loadAll: false,
                type: physiciantype === 'Territory' ? 'All' : 'favorites',
            });
        }
    };
    const handleDisableField = (fieldName, value) => {
        setDisableFields({
            ...disableFields,
            [fieldName]: value,
        });
    };
    const handleInputChange = (name, value) => {
        if (value === '') {
            setSelectedPhysicianData('');
            getPhysicanList({
                type: 'favorites',
                searchValue: '',
                isLoadAll: true,
            });
            setPhysicianType(
                physiciantype === 'Territory' ? 'Territory' : 'favorites'
            );
            dispatch(
                setPhysicianProcedureDropdownValue({
                    physicianType:
                        physiciantype === 'Territory'
                            ? 'Territory'
                            : 'favorites',
                })
            );
            handleDisableField('physician', false);
            physicianOnfocus();
            setPhysicianInputValue('');
        } else {
           
            getPhysicanList({
                type: 'All',
                searchValue: '',
                isLoadAll: true,
            });
        }
    };

    const physicianTypeChange = (type, fromSwitch = false) => {
        setPhysicianType(type);
        // setSelectedPhysicianData('');
        dispatch(
            setPhysicianProcedureDropdownValue({
                physicianType: type,
            })
        );
        if (!fromSwitch) {
            setPhysicianInputValue('');
            setSelectedPhysicianData('');
            dispatch(
                setPhysicianProcedureDropdownValue({
                    procedureDropdownValue: '',
                })
            );
            handleDisableField('physician', true);
        }
        dispatch(
            clearSingleDropDownList({
                name: 'physicianList',
            })
        );

        getPhysicanList({
            searchValue: '',
            loadAll: false,
            type: type === 'Territory' ? 'All' : 'favorites',
        });
    };

    const physicianAutoCompleteChangeHandler = (value, reason) => {
        // reason === true is the chevron/toggle click signal from DownIcon (not a real value change)
        // Skip to avoid triggering unintended API calls with physicianType: 'All'
        if (reason === true) return;

        if (reason==='clear') {
            // handleOnfocus(null, 'physician');
            setPhysicianInputValue('');
            //showOptionsAfterClose('physician', true);
            setSelectedPhysicianData('');
             handleInputChange('physicianId', '');
        }
        if(value){
            handleInputChange('physicianId', value);
            setSelectedPhysicianData(value);
            setPhysicianInputValue(
            value?.physicianDisplayName
                ? value?.physicianDisplayName
                : ''
        );}
        if(value==='') handleDisableField('physician', true);
      
    };

    // if(!((salesOrg === 'S024' || countryISOCode === 'JP') && physicianDropdownZGReportUsageVisibility === 'VISIBLE')){
    //     return <></>;
    // }
    return (
        <>
            <PhysicianTerritoryStyle
                showProcedureDropdown={showProcedureDropdown}
            >
                <Title
                    showAstrisk={
                        isReportUsageFlow
                            ? mandate && physicianDropdownZGReportUsageMandatory === MANDATORY
                            : mandate || physicianDropdownZGReportUsageMandatory === MANDATORY
                    }
                >
                    {t('common.physicianLabel')}
                </Title>
                <RadioRowDiv marginBottom="15px">
                    <RadioButton
                        isChecked={physiciantype == 'favorites' ? true : false}
                        id={'physician-favorite'}
                        label={t('common.favoritesLabel')}
                        handleChange={() => {
                            try {
                            physicianTypeChange('favorites');
                            
                            (Object.keys(selectedPhysicianData).length === 0 &&
                            physicianRef.current?.focus());
                             } catch (error) {
                                    logErrorToConsole(error);
                            }
                        }}
                        value={physiciantype}
                        fontFamilyStyle={FONT_FAMILY_REGULAR}
                        fontSize={BASE_TEXT_PX}
                        width={'14px'}
                    />
                    <RadioButton
                        isChecked={physiciantype == 'Territory' ? true : false}
                        id={'physician-territory'}
                        label={
                            salesOrg === 'S024' || countryISOCode === 'JP'
                                ? t('common.hospital')
                                : t('common.territoryLabel')
                        }
                        handleChange={() => {
                            try {
                            physicianTypeChange('Territory');
                            (Object.keys(selectedPhysicianData).length === 0 &&
                            physicianRef.current?.focus());
                                } catch (error) {
                                    logErrorToConsole(error);
                            }
                        }}
                        value={physiciantype}
                        fontFamilyStyle={FONT_FAMILY_REGULAR}
                        fontSize={BASE_TEXT_PX}
                        width={'14px'}
                    />
                </RadioRowDiv>
                <AutoComplete
                    style={{
                        width:
                            winWidth > sizes.mediumDevice ||
                            winWidth < sizes.mobileDevice
                                ? '100%'
                                : '350px',
                    }}
                    isFromPhysician={physicianInputValue ? false : true} 
                    inputRef={physicianRef}
                    showScrollBar={true}
                    disableClearable={false}
                    noOptionStyle={true}
                    value={selectedPhysicianData ?? ''}
                    options={physicians}
                    onFocus={(event) => handleOnfocus(event, 'physicians')}
                    itemTemplate={(option) =>
                        AccountTemplate(
                            option,
                            'physician',
                            physiciantype,
                            physicianInputValue
                        )
                    }
                    placeholder={t('common.selectOrSearchPhusician')}
                    field="physicianDisplayName"
                    filterField="physicanFormattedName"
                    loadingText={t('common.loadingText')}
                    noOptionsText={
                        physicianInputValue?.length >= 1 ? null : renderNoOption
                    }
                    optionValue="physicianId"
                    onChange={(value, reason) =>
                        physicianAutoCompleteChangeHandler(value, reason)
                    }
                    id="reportUsage-procedure-physicianTerritory-physician"
                    loading={physiciansOptionLoading}
                    onInputChange={(event, value, reset) => {
                        if(value && value?.trim() !== ''){
                            handleSearch(event, value, reset, 'physician');
                         }   
                         else if(reset==='clear'){
                            handleSearch('', '', reset, 'physician');
                         }
                    }}
                    inputValue={physicianInputValue}
                    onOpen={() => handleDisableField('physician', true)}
                    onClose={() => handleDisableField('physician', false)}
                    open={Object.keys(selectedPhysicianData).length > 0 ? false : disableFields.physician}
                    readOnly={Object.keys(selectedPhysicianData).length > 0}
                    optionPadding={
                        physicianInputValue?.length >= 1 &&
                        physiciantype == 'Territory'
                            ? '5px'
                            : '0px'
                    }
                    detailsMargin
                    // hideNoOptionText={
                    //     physiciantype != 'Territory' &&
                    //     physicianInputValue?.length >= 1
                    //         ? true
                    //         : false
                    // }
                    hideNoOptionText={false}
                    marginLeft={'1.5px'}
                    zIndex={zIndex}
                
                />
            </PhysicianTerritoryStyle>
        </>
    );
};

export default PhysicianTerritory;
